/**
 * @generated SignedSource<<927aefb2daeddcbd6c189a6b55e0c558>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TrackingDetails_viewer$data = {
  readonly transaction?: {
    readonly buyerTimelineStatuses: {
      readonly completed: boolean | null;
      readonly shipped: boolean | null;
    } | null;
    readonly isCanceled: boolean | null;
    readonly shipment: {
      readonly deliveryDateRangeDisplay: string | null;
      readonly estimatedShippingDate: string | null;
      readonly isBuyerShipping: boolean | null;
      readonly shipmentTracking: {
        readonly lateByDate: string | null;
      } | null;
      readonly " $fragmentSpreads": FragmentRefs<"CarrierTrackingDetails_shipment">;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"EstimatedDeliveryDateDisplay_transaction" | "EstimatedShippingDateDisplay_transaction">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"EstimatedDeliveryDateDisplay_viewer" | "EstimatedShippingDateDisplay_viewer">;
  readonly " $fragmentType": "TrackingDetails_viewer";
};
export type TrackingDetails_viewer$key = {
  readonly " $data"?: TrackingDetails_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"TrackingDetails_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "hasOrderId"
    },
    {
      "kind": "RootArgument",
      "name": "transactionId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "TrackingDetails_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EstimatedShippingDateDisplay_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EstimatedDeliveryDateDisplay_viewer"
    },
    {
      "condition": "hasOrderId",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "transactionId",
              "variableName": "transactionId"
            }
          ],
          "concreteType": "Transaction",
          "kind": "LinkedField",
          "name": "transaction",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "EstimatedDeliveryDateDisplay_transaction"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "EstimatedShippingDateDisplay_transaction"
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isCanceled",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Shipment",
              "kind": "LinkedField",
              "name": "shipment",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "CarrierTrackingDetails_shipment"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "deliveryDateRangeDisplay",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "estimatedShippingDate",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isBuyerShipping",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ShipmentTracking",
                  "kind": "LinkedField",
                  "name": "shipmentTracking",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lateByDate",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "TransactionBuyerTimelineStatuses",
              "kind": "LinkedField",
              "name": "buyerTimelineStatuses",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "shipped",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "completed",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "ca27978ebc05cad48a029ae83630c17b";

export default node;
